import type { InjectionKey } from 'vue';

export const removeLayerSymbol: InjectionKey<() => void> = Symbol('removeLayer');
